function ContactSection() {
  return (
    <section id="contato" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-primary-700 tracking-wider uppercase mb-2">
            Venha nos visitar
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            Onde Estamos
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            Atendimento presencial e online. Aguardamos sua visita!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8">
          {/* Mapa */}
          <div className="lg:col-span-3 rounded-xl overflow-hidden border border-background-200/70 shadow-sm">
            <iframe
              src="https://maps.google.com/maps?q=Av.%20Pres.%20Vargas,%201998%20-%20Centro,%20S%C3%A3o%20Borja%20-%20RS,%2097670-000&t=&z=17&ie=UTF8&iwloc=&output=embed"
              title="Localização Maçã Verde"
              className="w-full h-[300px] md:h-[380px] border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Info lado */}
          <div className="lg:col-span-2 flex flex-col justify-center gap-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 shrink-0">
                <i className="ri-map-pin-line text-lg" />
              </div>
              <div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">Endereço</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Av. Pres. Vargas, 1998
                  <br />
                  Centro, São Borja - RS
                  <br />
                  CEP 97670-000
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 shrink-0">
                <i className="ri-time-line text-lg" />
              </div>
              <div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">Horário de Atendimento</h3>
                <p className="text-sm text-foreground-600">
                  Segunda a Sábado: 9h às 18h
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 shrink-0">
                <i className="ri-whatsapp-line text-lg" />
              </div>
              <div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">WhatsApp</h3>
                <a
                  href="https://wa.me/55999260502?text=Ol%C3%A1!%20Gostaria%20de%20conhecer%20os%20produtos%20da%20Ma%C3%A7%C3%A3%20Verde."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                >
                  (11) 99999-9999
                </a>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 shrink-0">
                <i className="ri-instagram-line text-lg" />
              </div>
              <div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">Instagram</h3>
                <a
                  href="https://instagram.com/mundomacaverde"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                >
                  @mundomacaverde
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;